/// <reference path="../objects/interfaces/idefaultformscope.ts" />
/// <reference path="../objects/classes/basecontroller.ts" />

module App.Controllers
{
    export interface IInactiveController {
        
    }

    export class InactiveController implements IInactiveController {
        static controllerId = 'inactiveController';

        static $inject = [
            '$scope',
            '$timeout',
            '$state',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId
        ];

        constructor(private $scope: App.Interfaces.IDefaultFormScope, private $timeout: ng.ITimeoutService, 
                    private $state: ng.ui.IStateService, private sessionService: App.Interfaces.ISessionService,
                    private navigationService: App.Interfaces.INavigationService) {

            this.setSoftResetInterval();
            this.setTotalResetInterval();

            //$(document).on("mousemove mousedown click touchstart touchmove keydown", () => {
            //    if (!this.softReminderShowing) {
            //        sessionService.lastChangeDateTime = new Date();
            //    }
            //});
        }

        softReminderShowing = false;
        softRemainder: number = 0;
        setSoftResetInterval = () => {
            if (this.softResetInterval != null)
                this.$timeout.cancel(this.softResetInterval);
            this.softResetInterval = this.$timeout(() => {
                //this.softRemainder = new Date().getTime() - this.sessionService.lastChangeDateTime.getTime();
                if (Constants.resetTimes.soft * 1000 * 60 <= this.softRemainder) {
                    this.softRemainder = 0;
                    if (this.$state.current.name != Constants.routeKeys.cardetail) {
                        if (!this.softReminderShowing) {
                            this.softReminderShowing = true;
                            $.fancybox.open(["#resetMessage"], {
                                href: "#resetMessage",
                                type: "inline",
                                title: 'Wat wilt u doen?',
                                beforeClose: () => {
                                    this.resetTimeout();
                                },
                                padding: 0,
                                wrapCSS: 'custom',
                                helpers: {
                                    title: {
                                        type: 'inside',
                                        position: 'top'
                                    }
                                }
                            });
                        }
                    } else {
                        this.softReminderShowing = false;
                    }
                }

                this.setSoftResetInterval();
            }, (Constants.resetTimes.soft * 1000 * 60) - this.softRemainder);
        }

        totalRemainder: number = 0;
        setTotalResetInterval = () => {
            if (this.totalResetInterval != null)
                this.$timeout.cancel(this.totalResetInterval);

            this.totalResetInterval = this.$timeout(() => {
                //this.totalRemainder = new Date().getTime() - this.sessionService.lastChangeDateTime.getTime();
                if (Constants.resetTimes.total * 1000 * 60 <= this.totalRemainder) {
                    this.totalRemainder = 0;
                    if (this.$state.current.name != Constants.routeKeys.cardetail) {
                        this.restart();
                    }
                }

                this.setTotalResetInterval();
            }, (Constants.resetTimes.total * 1000 * 60) - this.totalRemainder);
        }

        softResetInterval: ng.IPromise<any>;
        totalResetInterval: ng.IPromise<any>;

        resetTimeout = () => {
            //this.sessionService.lastChangeDateTime = new Date();
            this.softReminderShowing = false;
        }

        restart = () => {
            this.navigationService.goToStep(Constants.routeKeys.cardetail);
            //$.fancybox.close(true);
        }
    }

    app.controller(InactiveController.controllerId, InactiveController);

}